import Flex from 'components/Flex'
import styled from 'styled-components'
import { FONT } from 'theme/font'

export const SingleCard = styled(Flex)`
  background: ${props => props.background};
  padding: ${props => (props.padding ? props.padding : 0)};
  border: ${props => (props?.styleProps ? '1px #3249D7 solid' : '')};
  border-radius: 10px;
  width: ${props => props.width};
  height: ${props => (props.height ? props.height : 'auto')};
  cursor: pointer;
`
export const SingleCard1 = styled(Flex)`
  background: ${props => props.background};
  justify-content: center;
  align-items: center;
  border: ${props => (props?.styleProps ? '1px #3249D7 solid' : '')};
  border-radius: 10px;
  width: ${props => props.width};
  height: ${props => (props.height ? props.height : 'auto')};
  cursor: pointer;
`
export const CardText = styled.p`
  font-style: normal;
  font-weight: ${FONT?.FW_500};
  font-size: 12px;
  line-height: 22px;
  color: #808697;
  margin-bottom: 5px;
`
export const CardValue = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: ${FONT?.FW_700};
  font-size: 16px;
  line-height: 28px;
  color: #343e59;
  display: flex;
  gap: 7px;
  text-transform: capitalize;
`
export const TopHeader = styled(Flex)`
  position: relative;
  width: 100%;
  margin-top: 10px;
`
export const TopHeader1 = styled(Flex)`
  position: relative;
  width: 100%;
`
export const CursorPointer = styled.div`
  cursor: pointer;
  text-align: center;
  align-self: center;
`
export const SubText = styled.p`
  font-style: normal;
  font-weight: ${FONT?.FW_500};
  font-size: 12px;
  line-height: 12px;
  color: #808697;
  margin: 3px;
  margin-top: 8px;
  padding-right: 7px;
  padding-left: 6px;
`
